<div
  aria-labelledby="headPrimary1"
  class="common-va-widget-bg"
  id="primaryPanel1"
  role="tabpanel"
>
  <div
    [ngClass]="{
      'mobile-safari-container':
        isMobSafari && flightPlusHotel && !restrictFlightHotel
    }"
    class="book-widget-container container-padding-x"
    id="booking"
    role="region"
  >
    <div
      [ngStyle]="{ 'padding-bottom': '0.5rem', float: 'right' }"
      *ngIf="enableCloseButton"
    >
      <a
        class="hamburger-icon active"
        id="hamburger-icon"
        (click)="toggleWidget()"
        title="Close"
        aria-label="Close navigation menu"
        att.aria-controls="headerLinksContainer"
      >
        <span class="line line-1"></span>
        <span class="line line-2"></span>
        <span class="line line-3"></span>
      </a>
    </div>
    <div #inMobile class="d-block d-lg-none"></div>
    <form
      *ngIf="bookWidgetForm && isReady"
      #formStoreDir="ngcFormStore"
      #ngbookWidgetForm
      (ngSubmit)="onSubmit(ngbookWidgetForm, $event)"
      [action]="actionUrl"
      [formGroup]="bookWidgetForm"
      [makeVisible]="isSubmitted"
      [method]="actionMethod"
      [ngc-form-store]="'bookWidgetForm'"
      [ngc-formNameToValidate]="'bookWidgetForm'"
      [ngc-formToValidate]="bookWidgetForm"
      name="bookWidgetForm"
      ngc-error-handler
    >
      <ngc-make-correction></ngc-make-correction>

      <div
        [ngClass]="{
          'book-container-padding-bottom':
            isFlightPlusHotelChecked ||
            (isAdvSearchExpanded && selectTripType !== 'MULTICITY')
        }"
        class="container booking-widget_container-mobile"
      >
        <div
          [ngClass]="{
            'ml-lg-1': selectTripType === 'MULTICITY',
            eDocApplied: isEdocApplied
          }"
          class="form-row"
        >
          <div
            class="col-lg-10 pl-xl-0 pl-xxl-0 p-0 pt-sm-3 safari-mob-padding"
          >
            <div class="form-row">
              <div
                *ngIf="selectTripType !== 'MULTICITY'"
                class="col-lg-4 text-center offset-md-2 col-md-8 offset-lg-0 pl-xl-0 pl-xxl-0"
                formGroupName="airports"
              >
                <div class="row">
                  <a
                    #deptAirportLookupDir="ngcAirportLookupDirective"
                    (click)="
                      deptAirportLookupDir?.openLookupModal(0);
                      loadSavedSearchOnClick()
                    "
                    (keydown.Enter)="loadSavedSearchOnClick()"
                    (keydown)="
                      $event.keyCode !== 13 &&
                      (($event.keyCode >= 65 && $event.keyCode <= 90) ||
                        ($event.keyCode >= 96 && $event.keyCode <= 105) ||
                        ($event.keyCode >= 48 && $event.keyCode <= 57))
                        ? deptAirportLookupDir?.openLookupModal()
                        : ''
                    "
                    (savedFromToAirport)="setSaved($event)"
                    (searchedAirportCode)="
                      fromAirportcode = $event; fromCity = ''
                    "
                    (selectedAirport)="
                      fromAirportcode = $event.airportCode;
                      fromCountryCode = $event.countryCode;
                      fromCity =
                        ($event.city && $event.city.trim() !== ''
                          ? $event.city.trim()
                          : '') +
                        ($event.city &&
                        $event.city.trim() !== '' &&
                        $event.region &&
                        $event.region.trim() !== ''
                          ? ', '
                          : '') +
                        ($event.region && $event.region.trim() !== ''
                          ? $event.region.trim()
                          : '');
                      resetODPairRestrictions()
                    "
                    (selectedRecentSearch)="displayRecentSearch($event)"
                    [attr.aria-describedby]="
                      validationerrormessageFrom.shouldShow
                        ? validationerrormessageFrom.getId
                        : ''
                    "
                    [initialLookupKey]="fromAirportcode"
                    [lookupTitle]="'Origin'"
                    [recentSearchSelected]="recentSearches"
                    [recentSearchsAvailable]="recentSearchsAvailable"
                    [savedSearchesAvailable]="savedSearchesAvailable"
                    [savedSearches]="savedSearches"
                    [widgetOnTop]="widgetOnTop"
                    aria-haspopup="true"
                    class="focusable-element from-container col-5 col-lg-5 col-sm-5 order-1 p-0 no-underline"
                    href="javascript:void(0);"
                    id="fromAirportName"
                    ngc-airport-lookup-directive
                  >
                    <span
                      [innerHTML]="
                        fromAirportcode && fromAirportcode !== ''
                          ? fromAirportcode
                          : fromAirportLabel
                      "
                      class="airport-code d-block"
                    ></span>
                    <span class="sr-only">Departure Airport or City</span>
                    <span
                      [innerHTML]="
                        getValidStringValue(fromCity, content?.travelOrigin)
                      "
                      class="airport-desc"
                    ></span>

                    <input
                      [(ngModel)]="fromAirportcode"
                      [formControlName]="'fromAirportcode'"
                      name="fromAirportCode"
                      type="hidden"
                      value="ATL"
                    />

                    <input
                      [(ngModel)]="fromCountryCode"
                      [formControlName]="'fromCountryCode'"
                      name="fromCountryCode"
                      type="hidden"
                    />

                    <input
                      [(ngModel)]="fromCity"
                      [formControlName]="'fromCity'"
                      name="fromCity"
                      type="hidden"
                      value="Atlanta, GA"
                    />
                  </a>

                  <a
                    #toAirportLookupDir="ngcAirportLookupDirective"
                    (click)="
                      toAirportLookupDir?.openLookupModal();
                      loadSavedSearchOnClick()
                    "
                    (keydown.Enter)="loadSavedSearchOnClick()"
                    (keydown)="
                      $event.keyCode !== 13 &&
                      (($event.keyCode >= 65 && $event.keyCode <= 90) ||
                        ($event.keyCode >= 96 && $event.keyCode <= 105) ||
                        ($event.keyCode >= 48 && $event.keyCode <= 57))
                        ? toAirportLookupDir?.openLookupModal()
                        : ''
                    "
                    (savedFromToAirport)="setSaved($event)"
                    (searchedAirportCode)="toAirportcode = $event; toCity = ''"
                    (selectedAirport)="
                      toAirportcode = $event.airportCode;
                      toCountryCode = $event.countryCode;
                      toCity =
                        ($event.city && $event.city.trim() !== ''
                          ? $event.city.trim()
                          : '') +
                        ($event.city &&
                        $event.city.trim() !== '' &&
                        $event.region &&
                        $event.region.trim() !== ''
                          ? ', '
                          : '') +
                        ($event.region && $event.region.trim() !== ''
                          ? $event.region.trim()
                          : '');
                      setODPairRestrictions($event)
                    "
                    (selectedRecentSearch)="displayRecentSearch($event)"
                    [attr.aria-describedby]="
                      validationerrormessageTo.shouldShow
                        ? validationerrormessageTo.getId
                        : ''
                    "
                    [initialLookupFromKey]="fromAirportcode"
                    [initialLookupKey]="toAirportcode"
                    [lookupTitle]="'Destination'"
                    [recentSearchSelected]="recentSearches"
                    [recentSearchsAvailable]="recentSearchsAvailable"
                    [savedSearchesAvailable]="savedSearchesAvailable"
                    [savedSearches]="savedSearches"
                    [widgetOnTop]="widgetOnTop"
                    aria-haspopup="true"
                    class="to-container col-5 col-lg-5 col-sm-5 order-3 p-0 no-underline"
                    href="javascript:void(0);"
                    id="toAirportName"
                    ngc-airport-lookup-directive
                  >
                    <span
                      [innerHTML]="
                        toAirportcode && toAirportcode !== ''
                          ? toAirportcode
                          : toAirportLabel
                      "
                      class="airport-code d-block"
                    ></span>
                    <span class="sr-only">Destination Airport or City</span>
                    <span
                      [innerHTML]="
                        getValidStringValue(
                          toCity,
                          content?.travelDestinationLabel
                        )
                      "
                      class="airport-desc"
                    ></span>

                    <input
                      [(ngModel)]="toAirportcode"
                      [formControlName]="'toAirportcode'"
                      name="arrivalCity"
                      type="hidden"
                    />

                    <input
                      [(ngModel)]="toCountryCode"
                      [formControlName]="'toCountryCode'"
                      name="toCountryCode"
                      type="hidden"
                    />

                    <input
                      [(ngModel)]="toCity"
                      [formControlName]="'toCity'"
                      name="toCity"
                      type="hidden"
                    />
                  </a>

                  <div
                    class="swap-container col-2 col-lg-2 col-sm-2 order-2 p-0"
                  >
                    <a
                      (click)="swapCity()"
                      (focusout)="reverseBtnAction()"
                      class="swapfield d-inline-block icon-swap"
                      href="javascript:void(0);"
                      role="button"
                      title="Reverse origin and destination city or airport"
                    >
                      <span *ngIf="showSwapSpan" class="sr-only" role="alert">
                        Reversed origin and destination city or airport
                      </span>
                    </a>
                  </div>
                </div>

                <div class="row no-gutters">
                  <ngc-validation-error-message
                    #validationerrormessageFrom
                    [control]="
                      bookWidgetForm?.controls.airports.controls.fromAirportcode
                    "
                    [controlname]="'fromAirportName'"
                    [focusedFieldId]="'fromAirportName'"
                    [makeVisible]="isSubmitted"
                    class="col-lg-5 col-sm-5 error-message-padding"
                  ></ngc-validation-error-message>
                  <ngc-validation-error-message
                    #validationerrormessageTo
                    [control]="
                      bookWidgetForm?.controls.airports.controls.toAirportcode
                    "
                    [controlname]="'toAirportName'"
                    [focusedFieldId]="'toAirportName'"
                    [makeVisible]="isSubmitted"
                    class="col-lg-5 col-sm-5 offset-lg-2 offset-sm-2 error-message-padding"
                  ></ngc-validation-error-message>
                </div>
                <ngc-validation-error-message
                  [control]="bookWidgetForm?.controls.airports"
                  [controlname]="'airports'"
                  [focusedFieldId]="airportFieldToFocus()"
                  [makeVisible]="isSubmitted"
                ></ngc-validation-error-message>

                <input
                  id="invalidAirportCodes"
                  name="invalidAirportCodes"
                  type="hidden"
                />
              </div>

              <div
                [class.d-sm-none]="!isWidgetExpanded"
                [ngClass]="{
                  'col-lg-2': selectTripType !== 'MULTICITY',
                  'col-lg-4': selectTripType === 'MULTICITY',
                  'select-container-up-md': !deviceTypes.isDesktop,
                  'booking-element': content?.searchoptionLabel
                }"
                class="col-sm-12 select_dropdown trip-type-container trip-element d-lg-block offset-md-2 col-md-8 offset-lg-0 book-element mb-3 mb-lg-0 select-container select-container-down-md"
              >
                <label class="sr-only" for="selectTripType">
                  Trip Type:, changes will reload the page
                </label>

                <select
                  #tripTypeDropdown="ngcSelectDirective"
                  (change)="setTripType($event.target.value, true)"
                  (customChangeEvent)="
                    customChangeEventHandlerForTripType($event, true)
                  "
                  *ngIf="deviceTypes.isDesktop"
                  [(ngModel)]="selectTripType"
                  [attr.disabled]="disableTripType ? true : null"
                  [formControlName]="'selectTripType'"
                  [ngClass]="{
                    'trip-type-dropdown': selectTripType !== 'MULTICITY'
                  }"
                  [selectedIndex]="tripTypeDropIndex"
                  autorotateoption="true"
                  class="drop-down first-control form-control"
                  customClassName="blue-theme"
                  customLoadingCheck="true"
                  data-dluiSelect
                  id="selectTripType"
                  name="selectTripType"
                  openonenter="true"
                  visibleLabel="false"
                >
                  <option
                    *ngFor="let trip of uiTripTypes; let i = index"
                    [selected]="tripTypeDropIndex"
                    [value]="trip.tripTypeValue"
                  >
                    {{ trip.tripTypeTitle }}
                  </option>
                </select>

                <select
                  (change)="setTripType($event.target.value, true)"
                  *ngIf="!deviceTypes.isDesktop"
                  [(ngModel)]="selectTripType"
                  [attr.disabled]="disableTripType ? true : null"
                  [formControlName]="'selectTripType'"
                  [ngClass]="{
                    'trip-type-dropdown': selectTripType !== 'MULTICITY'
                  }"
                  [selectedIndex]="tripTypeDropIndex"
                  class="drop-down first-control form-control"
                  id="selectTripType"
                  name="selectTripType"
                  visibleLabel="false"
                >
                  <option
                    *ngFor="let trip of uiTripTypes"
                    [selected]="tripTypeDropIndex"
                    [value]="trip.tripTypeValue"
                  >
                    {{ trip.tripTypeTitle }}
                  </option>
                </select>
                <span
                  *ngIf="!deviceTypes.isDesktop"
                  [ngClass]="{ 'booking-caret': content?.searchoptionLabel }"
                  class="icon-Dropdown-caret"
                ></span>
              </div>

              <div
                *ngIf="selectTripType !== 'MULTICITY'"
                [class.d-sm-none]="!isWidgetExpanded"
                [ngClass]="{ 'booking-element': content?.searchoptionLabel }"
                class="col-lg-3 col-sm-12 d-lg-block offset-md-2 col-md-8 offset-lg-0 book-element"
              >
                <date-selection-view
                  (inputBlur)="inputBlur($event)"
                  (inputClick)="inputClick($event)"
                  (inputFocus)="inputFocus($event)"
                  [checkJourneyType]="selectTripType"
                  [displayDateFormat]="'Mmm/dd'"
                  [formObj]="bookWidgetForm?.controls.dates"
                  [formObject]="bookWidgetForm?.controls.dates"
                  [index]="1"
                  [isFlexDatesDisabledByEdoc]="
                    disabledByEdocData?.disableFlexibleDates
                  "
                  [isFlexDatesDisabled]="
                    isMilesMobileRedirect || content?.searchoptionLabel
                      ? 'false'
                      : awardTravel
                      ? 'true'
                      : 'false'
                  "
                  [isFlexDates]="
                    isMilesMobileRedirect || content?.searchoptionLabel
                      ? 'false'
                      : isFlexAirPort
                      ? 'false'
                      : 'true'
                  "
                  [travelType]="
                    selectTripType === 'ROUND_TRIP' ? 'Return' : 'Departure'
                  "
                  dateFor="departureDate"
                  departPlaceHolderText="{{ content?.departLabel }}"
                  departlabelText="{{ content?.departLabel }}"
                  returnPlaceHolderText="{{ content?.returnLabel }}"
                  returnlabelText="{{ content?.returnLabel }}"
                ></date-selection-view>
                <ngc-validation-error-message
                  [control]="bookWidgetForm?.controls.dates"
                  [controlname]="'departureDate'"
                  [focusedFieldId]="'input_departureDate_1'"
                  [index]="1"
                  [makeVisible]="isSubmitted"
                ></ngc-validation-error-message>
              </div>

              <div
                [class.d-sm-none]="!isWidgetExpanded"
                [ngClass]="{
                  'offset-lg-0': selectTripType !== 'MULTICITY',
                  'offset-lg-1 pl-lg-0 passenger-container':
                    selectTripType === 'MULTICITY',
                  'select-container-up-md': !deviceTypes.isDesktop,
                  'booking-element': content?.searchoptionLabel,
                  hideArrowForCorporateUser:
                    corpPartner.restrictPaxToOne || restrictNewPaxToOne
                }"
                class="col-sm-12 col-lg-3 d-lg-block offset-md-2 col-md-8 book-element booking-element select-container select-container-down-md passenger-booking-element"
              >
                <label class="sr-only" for="passenger">Passenger</label>

                <select
                  #pasDropdown="ngcSelectDirective"
                  (customChangeEvent)="customChangeEventHandlerForPax($event)"
                  *ngIf="
                    deviceTypes.isDesktop &&
                    !vaPaxDropDown &&
                    !disablePaxDropDown
                  "
                  [(ngModel)]="passenger"
                  [formControlName]="'passenger'"
                  [formControlName]="'passenger'"
                  [attr.disabled]="
                    corpPartner.restrictPaxToOne || restrictNewPaxToOne
                      ? true
                      : null
                  "
                  [selectedIndex]="passengerDropIndex"
                  autorotateoption="true"
                  class="drop-down form-control"
                  customClassName="blue-theme"
                  customLoadingCheck="true"
                  data-dluiSelect
                  id="passengers"
                  openonenter="true"
                  visibleLabel="false"
                >
                  <option
                    *ngFor="let passenger of content?.passengers"
                    [selected]="passengerDropIndex"
                    [value]="passenger.passengerId"
                  >
                    {{ passenger.passengerTitle }}
                  </option>
                </select>

                <select
                  #pasDropdown="ngcSelectDirective"
                  (customChangeEvent)="customChangeEventHandlerForPax($event)"
                  *ngIf="
                    deviceTypes.isDesktop &&
                    !vaPaxDropDown &&
                    disablePaxDropDown
                  "
                  [(ngModel)]="passenger"
                  [formControlName]="'passenger'"
                  [attr.disabled]="
                    corpPartner.restrictPaxToOne || restrictNewPaxToOne
                      ? true
                      : null
                  "
                  [selectedIndex]="passengerDropIndex"
                  autorotateoption="true"
                  class="drop-down form-control eDoc"
                  customClassName="blue-theme"
                  customLoadingCheck="true"
                  data-dluiSelect
                  id="passengers"
                  openonenter="true"
                  visibleLabel="false"
                >
                  <option
                    *ngFor="let passenger of eDocPassengerArray"
                    [selected]="passengerDropIndex"
                    [value]="passenger.passengerId"
                  >
                    {{ passenger.passengerTitle }}
                  </option>
                </select>

                <select
                  (change)="customChangeEventHandlerForPax($event.target.value)"
                  *ngIf="
                    !deviceTypes.isDesktop &&
                    !vaPaxDropDown &&
                    !disablePaxDropDown
                  "
                  [(ngModel)]="passenger"
                  [attr.disabled]="
                    corpPartner.restrictPaxToOne || restrictNewPaxToOne
                      ? true
                      : null
                  "
                  [formControlName]="'passenger'"
                  [selectedIndex]="passengerDropIndex"
                  class="drop-down form-control"
                  id="passengers"
                  visibleLabel="false"
                >
                  <option
                    *ngFor="let passenger of content?.passengers"
                    [selected]="passengerDropIndex"
                    [value]="passenger.passengerId"
                  >
                    {{ passenger.passengerTitle }}
                  </option>
                </select>

                <select
                  (change)="customChangeEventHandlerForPax($event.target.value)"
                  *ngIf="
                    !deviceTypes.isDesktop &&
                    !vaPaxDropDown &&
                    disablePaxDropDown
                  "
                  [(ngModel)]="passenger"
                  [attr.disabled]="
                    corpPartner.restrictPaxToOne || restrictNewPaxToOne
                      ? true
                      : null
                  "
                  [formControlName]="'passenger'"
                  [selectedIndex]="passengerDropIndex"
                  class="drop-down form-control eDoc"
                  id="passengers"
                  visibleLabel="false"
                >
                  <option
                    *ngFor="let passenger of eDocPassengerArray"
                    [selected]="passengerDropIndex"
                    [value]="passenger.passengerId"
                  >
                    {{ passenger.passengerTitle }}
                  </option>
                </select>

                <select
                  (change)="customChangeEventHandlerForPax($event.target.value)"
                  *ngIf="deviceTypes.isMobile && vaPaxDropDown && !isMultiPax"
                  [(ngModel)]="passenger"
                  [attr.disabled]="
                    corpPartner.restrictPaxToOne || restrictNewPaxToOne
                      ? true
                      : null
                  "
                  [formControlName]="'passenger'"
                  [selectedIndex]="passengerDropIndex"
                  class="drop-down form-control"
                  id="passengers"
                  visibleLabel="false"
                >
                  <option
                    *ngFor="let passenger of content?.passengers"
                    [selected]="passengerDropIndex"
                    [value]="passenger.passengerId"
                  >
                    {{ passenger.passengerTitle }}
                  </option>
                </select>
                <ngc-childPassenger
                  (setPassenger)="setPassenger($event)"
                  *ngIf="vaPaxDropDown && isMultiPax"
                  [queryParam]="queryParam"
                ></ngc-childPassenger>

                <span
                  *ngIf="
                    (!corpPartner.restrictPaxToOne || !restrictNewPaxToOne) &&
                    !deviceTypes.isDesktop &&
                    !vaPaxDropDown
                  "
                  [ngClass]="{ 'booking-caret': content?.searchoptionLabel }"
                  class="icon-Dropdown-caret"
                ></span>
                <ngc-validation-error-message
                  [control]="bookWidgetForm?.controls.passenger"
                  [controlname]="'passenger'"
                  [focusedFieldId]="'passenger'"
                  [makeVisible]="isSubmitted"
                ></ngc-validation-error-message>
              </div>
            </div>

            <ngc-multicity
              (advancedSearchClicked)="
                toggleAdvancedSearch(inMobile?.offsetParent !== null, $event)
              "
              (setODPairRestrictions)="setMultiCityRestriction($event)"
              (tripTypeChnagedTriggered)="
                tripTypeChnagedTriggeredHandler($event)
              "
              *ngIf="selectTripType === 'MULTICITY'"
              [bookContent]="content"
              [bookWidgetForm]="bookWidgetForm"
              [errorHandler]="errorHandler"
              [formStoreDir]="formStoreDir"
              [isAdvSearchExpanded]="isAdvSearchExpanded"
              [isWidgetExpanded]="isWidgetExpanded"
              [recentSearch]="recentlySearchedMulticityData"
              class="col-lg-12 offset-lg-0 col-md-8 offset-md-2 pl-xxl-0 pl-sm-0 pr-sm-0"
            ></ngc-multicity>

            <div
              [ngClass]="{ 'search-option-ribbon': content?.searchoptionLabel }"
              class="form-row align-items-center"
            >
              <ngc-search-options
                (awardTravelChanged)="onAwardTravelChanged($event)"
                (flexiDatesChanged)="onFlexiDatesChanged($event)"
                (flightPlusHotelClicked)="isChecked($event)"
                *ngIf="content?.searchoptionLabel"
                [awardTravel]="awardTravel"
                [bookWidgetForm]="bookWidgetForm"
                [canBookNonRefundable]="canBookNonRefundable"
                [content]="content"
                [corpPartner]="corpPartner"
                [disabledByEdocData]="disabledByEdocData"
                [flightHotelContent]="flightHotelContent"
                [flightPlusHotel]="flightPlusHotel"
                [isFlexAirPort]="isFlexAirPort"
                [isMilesMobileRedirect]="isMilesMobileRedirect"
                [mpmTravel]="mpmTravel"
                [restrictCash]="restrictCash"
                [restrictFlightHotel]="restrictFlightHotel"
                [restrictMiles]="restrictMiles"
                [restrictmpmTravel]="restrictmpmTravel"
                [selectTripType]="selectTripType"
                class="col-sm-12 col-md-8 col-lg-10 p-0 pt-lg-3 pb-lg-3 offset-md-2 offset-lg-0 vs-search-option adv-search-options"
              ></ngc-search-options>

              <div
                #advancedSearch
                [class.d-sm-none]="!isWidgetExpanded"
                [ngClass]="{
                  'adv-search-mt': isAdvSearchExpanded,
                  'col-lg-12 basic-search ': !content?.searchoptionLabel,
                  'col-lg-2': content?.searchoptionLabel
                }"
                class="adv-search adv-search-label col-md-8 offset-lg-0 offset-md-2 text-lg-right text-sm-left d-lg-block my-lg-3 pl-md-0"
              >
                <span
                  *ngIf="
                    !content?.searchoptionLabel &&
                    flightPlusHotel &&
                    !restrictFlightHotel
                  "
                  class="checkbox-wrapper flightHotelDeals-span"
                >
                  <input
                    (change)="isChecked($event)"
                    [(ngModel)]="checked"
                    [formControlName]="'flightHotelDeals'"
                    class="flightHotelDeals"
                    id="flightHotelDeals"
                    name="flightHotelDeals"
                    type="checkbox"
                  />
                  <label class="content icon-Checked" for="flightHotelDeals">
                    {{ content?.flightPlusHotelLabel }}
                  </label>
                  <span class="fph-disclaimer" id="fph-disclaimer"></span>
                </span>
                <a
                  (click)="
                    toggleAdvancedSearch(
                      inMobile?.offsetParent !== null,
                      advancedSearch
                    )
                  "
                  [attr.aria-expanded]="isAdvSearchExpanded"
                  [ngClass]="{ show: isAdvSearchExpanded }"
                  class="arrow-wht-expander icon-advsearchtriangle"
                  href="javascript:void(0);"
                  id="adv-search"
                >
                  {{ content?.advancedSearchLabel }}
                </a>
              </div>
            </div>
          </div>

          <div
            [class.align-self-end]="selectTripType === 'MULTICITY'"
            [class.d-sm-none]="!isWidgetExpanded"
            [class.multicity-submitbutton]="selectTripType === 'MULTICITY'"
            [ngClass]="{
              'd-none': isAdvSearchExpanded,
              'd-lg-block': !isAdvSearchExpanded,
              'safari-cta-alignment':
                isFlightPlusHotelChecked ||
                (flightPlusHotel && !restrictFlightHotel && isMobSafari)
            }"
            class="pr-lg-0 pr-xl-0 col-lg-1 col-sm-6 text-right mt-lg-0 offset-sm-6 offset-md-6 col-md-4 offset-lg-0 offset-6 btn-submit-container book-submit-element"
          >
            <button
              *ngIf="content?.isShowSearch === 'true'"
              #booksubmitsearch
              class="btn btn-danger btn-book-submit last-focusable-element"
              id="btn-book-submit"
              type="submit"
            >
              {{ content?.searchButton }}
              <span class="sr-only">{{ content?.srOnlyText }}</span>
            </button>
            <button
              #booksubmit
              *ngIf="
                content?.isShowSearch === 'false' ||
                content?.isShowSearch === null
              "
              class="btn btn-danger rounded-circle btn-right-arrow icon-submitarrow circle-outline last-focusable-element"
              id="btn-book-submit"
              type="submit"
            >
              <span class="sr-only">Submit</span>
            </button>
          </div>
        </div>
      </div>

      <div
        #advSearchContainer
        [@widgetState]="widgetState"
        [ngClass]="{
          'd-none': !isAdvSearchExpanded,
          'multicity-adv-search-container': selectTripType === 'MULTICITY'
        }"
        class="adv-search-container"
      >
        <div
          [ngClass]="{ eDocApplied: isEdocApplied }"
          class="container container-padding-x advance-search-container"
        >
          <div
            class="form-row first-row px-3 px-lg-0 pl-0 pr-0 pl-sm-0 pr-sm-0"
          >
            <div
              *ngIf="!content?.toggleMiles"
              [ngClass]="mpmTravel ? 'col-lg-4' : 'col-lg-3'"
              class="offset-lg-0 col-md-8 offset-md-2 radio-tabs-wrapper adv-search-item"
            >
              <fieldset>
                <legend class="label legend text-capitalize">
                  <span aria-hidden="true">
                    {{ content?.showprice.toLowerCase() }}
                  </span>
                  <span class="sr-only">{{ content?.showprice }} help</span>
                  <a
                    #showpriceinHelp="ngcHelpModalDirective"
                    (click)="showpriceinHelp?.openHelpModal()"
                    [helpContent]="content?.tooltips?.get(tooltipValue)"
                    [type]="'showpricein'"
                    aria-haspopup="true"
                    class="show-pricein-help icon-help circle-outline"
                    draggable="false"
                    href="javascript:void(0);"
                    ngc-help-modal-directive
                  >
                    <span aria-hidden="true" class="sr-only">
                      {{ content?.showprice }} help
                    </span>
                  </a>
                </legend>

                <input
                  (click)="setAwardTravelMoney($event.target.value)"
                  [attr.disabled]="restrictCash ? true : null"
                  [checked]="'true'"
                  [formControlName]="'schedulePrice'"
                  class="radio-tab"
                  id="money"
                  name="schedulePrice"
                  type="radio"
                  value="price"
                />
                <label
                  [ngClass]="{ mpmLabel: !mpmTravel }"
                  class="pl-sm-0"
                  for="money"
                  id="moneyLabel"
                >
                  <span class="">{{ content?.moneyLabel }}</span>
                </label>

                <input
                  (click)="setAwardTravelMiles($event.target.value)"
                  [attr.disabled]="
                    restrictMiles ||
                    corpPartner.disableMiles ||
                    disabledByEdocData?.disableShowPriceIn
                      ? true
                      : null
                  "
                  [checked]="
                    bookWidgetForm?.controls['schedulePrice']?.value === 'miles'
                  "
                  [formControlName]="'schedulePrice'"
                  class="radio-tab"
                  id="miles"
                  name="schedulePrice"
                  type="radio"
                  value="miles"
                />
                <label
                  [ngClass]="{ mpmLabel: !mpmTravel }"
                  class="second-and-up"
                  for="miles"
                  id="milesLabel"
                >
                  <span class="">{{ content?.milesLabel }}</span>
                  <span *ngIf="corpPartner.disableMiles" class="sr-only">
                    Miles can not be used for the business travel
                  </span>
                </label>
                <span *ngIf="mpmTravel" class="milesplusmoney_wrapper">
                  <input
                    (click)="redirectMilesPlusMoney($event)"
                    [attr.disabled]="true"
                    [attr.disabled]="restrictmpmTravel ? true : null"
                    [checked]="
                      bookWidgetForm?.controls['schedulePrice']?.value ===
                      'milesplusmoney'
                    "
                    [formControlName]="'schedulePrice'"
                    class="radio-tab"
                    id="miles_plus_money"
                    name="schedulePrice"
                    type="radio"
                    value="milesplusmoney"
                  />
                  <label
                    class="second-and-up"
                    for="miles_plus_money"
                    id="milesPlusMoneyLabel"
                  >
                    <span class="sr-only">
                      selecting Miles plus cash will open the login page
                    </span>
                    <span class="">{{ content?.milesPlusMoneyLabel }}</span>
                  </label>
                </span>
              </fieldset>
            </div>

            <div
              *ngIf="
                content?.toggleMiles &&
                selectTripType !== 'MULTICITY' &&
                content?.nearByAirports &&
                ((awardTravel && isFlexDate) ||
                  (awardTravel && !isFlexDate) ||
                  (!awardTravel && !isFlexDate))
              "
              [ngClass]="{ 'modify-checkbox': content?.searchoptionLabel }"
              class="col-lg-3 offset-lg-0 col-md-8 offset-md-2 adv-search-item checkbox-wrapper booking-widget_fares-section searchOptionActive"
            >
              <fieldset>
                <legend
                  class="label legend text-capitalize booking-widget_fare-label"
                >
                  {{ content?.showFares }}
                </legend>
                <input
                  (change)="setFlexAirport()"
                  [attr.disabled]="
                    disabledByEdocData?.disableNearbyAirport ? true : null
                  "
                  [formControlName]="'nearbyAirports'"
                  class="top-2 advanceSearchOptionChk"
                  id="nearbyAirports"
                  name="nearbyAirports"
                  type="checkbox"
                />
                <label
                  [ngClass]="{
                    disableSearchText: disabledByEdocData?.disableNearbyAirport
                      ? true
                      : false
                  }"
                  class="nearbyAirports booking-widget_checkbox-mobile icon-Checked advSearchoptionLabel"
                  for="nearbyAirports"
                >
                  {{ content?.nearByAirports }}
                </label>
              </fieldset>
            </div>

            <div
              [ngClass]="{ 'select-container-up-md': !deviceTypes.isDesktop }"
              class="col-lg-4 offset-lg-0 col-md-8 offset-md-2 meeting-code-wrapper best-fares-wrapper select-container select-container-down-md adv-search-item"
            >
              <label
                class="d-block label text-capitalize"
                for="faresFor"
                id="faresForLabel"
              >
                {{ content?.bestFareLabel.toLowerCase() }}
              </label>
              <select
                #bestFareDropdown="ngcSelectDirective"
                #faresForDirective="ngcSelectDirective"
                (customChangeEvent)="
                  customChangeEventHandlerForFaresFor($event)
                "
                *ngIf="deviceTypes.isDesktop"
                [(ngModel)]="fareClass"
                [attr.disabled]="
                  disabledByEdocData?.disableBestFaresFor ? 'disabled' : null
                "
                [autorotateoption]="true"
                [formControlName]="'faresFor'"
                [selectedIndex]="faresForDropIndex"
                class="dropdown form-control"
                customClassName="blue-theme"
                customLoadingCheck="true"
                data-dluiSelect
                id="faresFor"
                name="faresFor"
                openonenter="true"
                visibleLabel="false"
              >
                <option
                  *ngFor="let brand of brands"
                  [selected]="faresForDropIndex"
                  [value]="brand.brandId"
                >
                  {{ brand.brandTitle }}
                </option>
              </select>

              <select
                (change)="
                  customChangeEventHandlerForFaresFor($event.target.value)
                "
                *ngIf="!deviceTypes.isDesktop"
                [(ngModel)]="fareClass"
                [attr.disabled]="
                  disabledByEdocData?.disableBestFaresFor ? true : null
                "
                [formControlName]="'faresFor'"
                [selectedIndex]="faresForDropIndex"
                class="dropdown form-control"
                id="faresFor"
                name="faresFor"
                visibleLabel="false"
              >
                <option
                  *ngFor="let brand of brands"
                  [selected]="faresForDropIndex"
                  [value]="brand.brandId"
                >
                  {{ brand.brandTitle }}
                </option>
              </select>
              <span
                *ngIf="!deviceTypes.isDesktop"
                class="icon-Dropdown-caret"
              ></span>

              <!-- <a *ngIf="content?.tooltips?.get('best-fares-for')"
                                          [attr.href]="content?.tooltips?.get('best-fares-for')?.tooltipExternalLink"
                                          [attr.target]="(content?.tooltips?.get('best-fares-for')?.openinnewTab === 'true')? '_blank' : ''"
                                          class="best-fares-help icon-help circle-outline"
                                          aria-haspopup="false"
                                          draggable="false">
                                          <span class="sr-only">{{content?.bestFareLabel}} help Opens in new window</span>
                                   </a> -->
              <a
                #cabinExperiencesHelp="ngcHelpModalDirective"
                (click)="cabinExperiencesHelp?.openHelpModal()"
                *ngIf="content?.tooltips?.get('best-fares-for')"
                [helpContent]="content?.tooltips?.get('best-fares-for')"
                [type]="'cabinExperiences'"
                aria-haspopup="true"
                class="best-fares-help icon-help circle-outline"
                draggable="false"
                href="javascript:void(0);"
                ngc-help-modal-directive
              >
                <span class="sr-only">{{ content?.bestFareLabel }} help</span>
              </a>
            </div>

            <div
              *ngIf="!awardTravel"
              class="col-lg-3 offset-lg-0 col-md-8 offset-md-2 meeting-code-wrapper pl-lg-0 adv-search-item"
            >
              <a
                #meetingCodeHelp="ngcHelpModalDirective"
                (click)="meetingCodeHelp?.openHelpModal()"
                [helpContent]="content?.tooltips?.get('meeting-code')"
                [type]="'meetingCode'"
                aria-haspopup="true"
                class="meeting-code-help icon-help circle-outline"
                draggable="false"
                href="javascript:void(0);"
                ngc-help-modal-directive
              >
                <span class="sr-only">{{ content?.meetingCode }} help</span>
              </a>

              <input
                #meetingEventCode
                (focus)="onFocusMeetingCode()"
                (focusout)="onFocusoutMeetingCode(meetingEventCode, $event)"
                (keydown.enter)="onEnterMeetingCode()"
                [attr.disabled]="
                  disabledByEdocData?.disableMeetingCode ? true : null
                "
                [formControlName]="'meetingEventCode'"
                [ngc-floatinglabel]="content?.meetingCodeFloatingLabel"
                [ngc-isOptional]="true"
                [ngc-isOptionalforPlaceholder]="true"
                [ngc-meeting-code-disclaimer]="edpMeetingCodeEventMessage"
                [ngc-placeholderValue]="content?.meetingCode"
                [ngc-show-edp-meeting-evt-msg]="showEdpMeetingEvtMsg"
                aria-describedby="meetingEventCodeMsgId"
                autocomplete="off"
                class="form-control pl-sm-1 pl-md-1 input-mobile-tab-class"
                id="meetingCode"
                maxlength="5"
                name="meetingEventCode"
                ondrop="return false"
                type="text"
              />
              <!--<a [attr.href]="content?.tooltips?.get('meeting-code')?.tooltipExternalLink" [attr.target]="(content?.tooltips?.get('meeting-code')?.openinnewTab === 'true')? '_blank' : ''"
                                      class="meeting-code-help icon-help circle-outline" aria-haspopup="false">
                                      <span class="sr-only">{{content?.meetingCode}} help Opens in new window</span>
                                    </a>-->
              <span
                [ngClass]="{
                  'meeting-msg': meetingEvntCdFlag,
                  'd-none': !meetingEvntCdFlag
                }"
                id="meetingEventCodeMsgId"
              >
                {{ edpMeetingCodeEventMessage }}
              </span>
              <ngc-validation-error-message
                [control]="bookWidgetForm?.controls.meetingEventCode"
                [controlname]="'meetingEventCode'"
                [focusedFieldId]="'meetingCode'"
                [makeVisible]="isSubmitted"
              ></ngc-validation-error-message>
            </div>

            <div
              *ngIf="
                !content?.toggleMiles &&
                content?.nearByAirports &&
                selectTripType !== 'MULTICITY' &&
                ((awardTravel && isFlexDate) || (awardTravel && !isFlexDate))
              "
              [ngClass]="{ 'modify-checkbox': content?.searchoptionLabel }"
              class="col-lg-4 offset-lg-0 col-md-8 offset-md-2 checkbox-wrapper top-40 adv-search-item"
            >
              <input
                (change)="setFlexAirport()"
                [attr.disabled]="
                  disabledByEdocData?.disableNearbyAirport ? true : null
                "
                [formControlName]="'nearbyAirports'"
                class="top-2"
                id="nearbyAirports"
                name="nearbyAirports"
                type="checkbox"
              />
              <label
                class="nearbyAirports booking-widget_checkbox-mobile icon-Checked"
                for="nearbyAirports"
              >
                {{ content?.nearByAirports }}
              </label>
            </div>
          </div>

          <div class="form-row second-row px-lg-0">
            <div
              *ngIf="
                !content?.searchoptionLabel &&
                !awardTravel &&
                content?.refundableFareLabel
              "
              class="col-lg-3 offset-lg-0 col-md-8 offset-md-2 checkbox-wrapper vs-flexCheckBox adv-search-item"
            >
              <input
                [attr.disabled]="
                  disabledByEdocData?.disableRefundableFares ? true : null
                "
                [formControlName]="'refundableFlightsOnly'"
                class="refundableFlightsOnly"
                id="refundableFlightsOnly"
                name="refundableFlightsOnly"
                type="checkbox"
              />
              <label class="content icon-Checked" for="refundableFlightsOnly">
                {{ content?.refundableFareLabel }}
              </label>

              <a
                #refundHelp
                #refundablefaresHelp="ngcHelpModalDirective"
                (click)="refundablefaresHelp?.openHelpModal()"
                *ngIf="content?.tooltips?.get('refundable-fares')"
                [helpContent]="content?.tooltips?.get('refundable-fares')"
                [type]="'refundablefares'"
                aria-haspopup="true"
                class="refundable-flights-help icon-help circle-outline"
                draggable="false"
                href="javascript:void(0);"
                ngc-help-modal-directive
              >
                <span class="sr-only">
                  {{ content?.refundableFareLabel }} help
                </span>
              </a>
            </div>

            <div
              *ngIf="
                !content?.toggleMiles &&
                !awardTravel &&
                selectTripType !== 'MULTICITY' &&
                !isFlexDate &&
                content?.nearByAirports
              "
              [ngClass]="{
                'col-lg-3': content?.searchoptionLabel && !content?.toggleMiles,
                'col-lg-4': !content?.searchoptionLabel
              }"
              class="col-lg-4 offset-lg-0 col-md-8 offset-md-2 checkbox-wrapper adv-search-item"
            >
              <input
                (change)="setFlexAirport()"
                [attr.disabled]="
                  disabledByEdocData?.disableNearbyAirport ? true : null
                "
                [formControlName]="'nearbyAirports'"
                [ngClass]="{ advSearchExpanded: content?.searchoptionLabel }"
                id="nearbyAirports"
                name="nearbyAirports"
                type="checkbox"
              />
              <label class="content icon-Checked" for="nearbyAirports">
                {{ content?.nearByAirports }}
              </label>
            </div>

            <div
              *ngIf="content?.ecertLabel"
              [ngClass]="{
                'eCert-award-travel offset-lg-7': awardTravel,
                'list-group': disabledByEdocData?.disableEdocLink,
                'offset-lg-4':
                  content?.searchoptionLabel &&
                  !content?.toggleMiles &&
                  !awardTravel,
                'offset-lg-7':
                  (content?.searchoptionLabel && content?.toggleMiles) ||
                  awardTravel
              }"
              [ngStyle]="{
                cursor: disabledByEdocData?.disableEdocLink
                  ? 'not-allowed'
                  : 'pointer'
              }"
              class="col-lg-4 offset-lg-0 pl-lg-1 col-md-4 mb-sm-2 mb-md-0 mb-lg-0 col-sm-6 offset-md-2 ecredits-wrapper adv-search-item"
            >
              <a
                (click)="openCorporateRewards($event)"
                [attr.href]="
                  disabledByEdocData?.disableEdocLink ? null : content?.ecertUrl
                "
                [attr.disabled]="disabledByEdocData?.disableEdocLink"
                [attr.tabindex]="
                  disabledByEdocData?.disableEdocLink ? '-1' : null
                "
                [attr.target]="content?.newWindow === 'true' ? '_blank' : ''"
                [ngClass]="{
                  'list-group-item list-group-item-action disabled ecreditDisabledByEdoc':
                    disabledByEdocData?.disableEdocLink
                }"
                class="content ecredits"
                id="ecredits"
              >
                {{ content?.ecertLabel }}
                <span class="icon-Dropdown-caret"></span>
                <span *ngIf="content?.newWindow === 'true'" class="sr-only">
                  Opens in new tab
                </span>
              </a>
            </div>

            <div
              class="col-lg-2 offset-lg-0 col-sm-6 col-md-4 p-md-0 p-sm-0 adv-search-submit"
            >
              <button
                *ngIf="content?.isShowSearch === 'true'"
                class="btn btn-danger btn-book-submit last-focusable-element"
                id="btn-book-adv-submit"
                id="btnSubmit"
                type="submit"
              >
                {{ content?.searchButton }}
                <span class="sr-only">{{ content?.srOnlyText }}</span>
              </button>
              <button
                *ngIf="
                  content?.isShowSearch === 'false' ||
                  content?.isShowSearch === null
                "
                class="btn btn-danger rounded-circle btn-right-arrow icon-submitarrow circle-outline float-right last-focusable-element"
                id="btn-book-adv-submit"
                id="btnSubmit"
                type="submit"
              >
                <span class="sr-only">Submit</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="!isWidgetAlwaysExpanded"
        class="form-row align-items-center mr-sm-0 ml-sm-0"
      >
        <div
          class="pr-lg-0 pr-xl-0 d-lg-none book-expander text-center col-sm-12 offset-md-2 col-md-8 offset-lg-0"
        >
          <a
            (click)="expandButtonClicked($event)"
            [class.widgetExpanded]="isWidgetExpanded"
            class="expand-container align-bottom d-inline-block"
            href="javascript:void(0); "
            role="button "
            title="Expand Book Widget "
          ></a>
        </div>
      </div>
      <!-- hidden fields -->
      <input
        *ngIf="content?.searchoptionLabel"
        [formControlName]="'schedulePrice'"
        id="schedulePrice"
        name="schedulePrice"
        type="hidden"
      />
      <input id="searchType" name="searchType" type="hidden" value="simple" />

      <input
        id="bookingPostVerify"
        name="bookingPostVerify"
        type="hidden"
        value="RTR_YES"
      />

      <input id="bundled" name="bundled" type="hidden" value="off" />

      <input
        [formControlName]="'deltaOnly'"
        [ngModel]="'off'"
        id="deltaOnly"
        name="deltaOnly"
        type="hidden"
        value="off"
      />

      <input id="dl" name="dl" type="hidden" value="y" />

      <input
        [formControlName]="'departureTime'"
        [ngModel]="'AT'"
        id="departureTime"
        name="departureTime"
        type="hidden"
        value="AT"
      />

      <input
        [formControlName]="'returnTime'"
        [ngModel]="'AT'"
        id="returnTime"
        name="returnTime"
        type="hidden"
        value="AT"
      />

      <input
        id="directServiceOnly"
        name="directServiceOnly"
        type="hidden"
        value="off"
      />

      <input
        id="dispatchMethod"
        name="dispatchMethod"
        type="hidden"
        value="findFlights"
      />

      <input id="fareBundle" name="fareBundle" type="hidden" value="B5-Coach" />

      <input
        id="flexMainRTRTravelDate"
        name="flexMainRTRTravelDate"
        type="hidden"
        value="off"
      />

      <input id="preferItinId" name="preferItinId" type="hidden" value="" />

      <input
        id="awards_medallionTraveler"
        name="medallionTraveler"
        type="hidden"
        value="0"
      />

      <input
        id="awards_displayPreferredOnly"
        name="displayPreferredOnly"
        type="hidden"
        value="0"
      />

      <input
        id="pol_widget_awards_calendarSearch"
        name="calendarSearch"
        type="hidden"
        value="false"
      />

      <input
        id="pol_widget_awards_pricingSearch"
        name="pricingSearch"
        type="hidden"
        value="true"
      />

      <input
        id="awards_directServiceOnly"
        name="directServiceOnly"
        type="hidden"
        value="off"
      />

      <input id="hiddenFieldsId" name="hiddenFieldsId" type="hidden" value="" />

      <input
        [formControlName]="'awardTravel'"
        [ngModel]="awardTravel"
        id="awardTravel"
        name="awardTravel"
        type="hidden"
        value="{{ awardTravel }}"
      />

      <input id="action" name="action" type="hidden" value="findFlights" />

      <input
        id="pageName"
        name="pageName"
        type="hidden"
        value="advanceSearchPage"
      />

      <input
        id="branchingOptions"
        name="branchingOptions"
        type="hidden"
        value=""
      />

      <input id="removeEdoc" name="removeEdoc" type="hidden" value="" />

      <input
        id="tripType_hidden"
        name="tripType"
        type="hidden"
        value="{{ selectTripType }}"
      />

      <input id="cacheKey" name="cacheKey" type="hidden" value="" />

      <input
        id="searchForRevenueAwards"
        name="shopType"
        type="hidden"
        value="{{ awardTravel ? 'AWARD' : 'REVENUE' }}"
      />

      <input
        id="flexAirportsSearch"
        name="flexAirport"
        type="hidden"
        value="{{ isFlexAirPort }}"
      />

      <input
        id="originAirportRadius"
        name="originAirportRadius"
        type="hidden"
        value="0"
      />

      <input
        id="destinationAirportRadius"
        name="destinationAirportRadius"
        type="hidden"
        value="0"
      />

      <input
        *ngIf="selectTripType !== 'MULTICITY'"
        id="originCity_hiiden"
        name="originCity"
        type="hidden"
        value="{{ fromAirportcode }}"
      />

      <input
        *ngIf="selectTripType !== 'MULTICITY'"
        id="destinationCity_heidden"
        name="destinationCity"
        type="hidden"
        value="{{ toAirportcode }}"
      />

      <input
        id="departureDate_hidden"
        name="departureDate"
        type="hidden"
        value="{{ forHiddendepartureDate }}"
      />

      <input
        id="returnDate_hidden"
        name="returnDate"
        type="hidden"
        value="{{ forHiddenreturnDate }}"
      />

      <input
        id="is_Flex_Search"
        name="is_Flex_Search"
        type="hidden"
        value="true"
      />

      <input
        id="datesFlexible"
        name="datesFlexible"
        type="hidden"
        value="{{ isFlexDate }}"
      />

      <input id="flexDays" name="flexDays" type="hidden" value="3" />

      <input
        id="bestFare_hidden"
        name="bestFare"
        type="hidden"
        value="{{ fareClass }}"
      />

      <input
        id="fareFamily_hidden"
        name="fareFamily"
        type="hidden"
        value="{{ fareClass }}"
      />

      <input
        id="is_award_travel"
        name="is_award_travel"
        type="hidden"
        value="{{ awardTravel }}"
      />

      <input
        id="paxCount"
        name="paxCount"
        type="hidden"
        value="{{ passenger }}"
      />

      <input
        id="flexDate"
        name="flexDate"
        type="hidden"
        value="{{ isFlexDate }}"
      />

      <input
        id="searchByCabin"
        name="searchByCabin"
        type="hidden"
        value="true"
      />

      <input
        id="cabinFareClass"
        name="cabinFareClass"
        type="hidden"
        value="{{ forHiddencabinFareClass }}"
      />
      <input
        *ngIf="adtCount !== null"
        id="adtCount"
        name="adtCount"
        type="hidden"
        value="{{ adtCount }}"
      />
      <input
        *ngIf="gbeCount !== null"
        id="gbeCount"
        name="gbeCount"
        type="hidden"
        value="{{ gbeCount }}"
      />
      <input
        *ngIf="cnnCount !== null"
        id="cnnCount"
        name="cnnCount"
        type="hidden"
        value="{{ cnnCount }}"
      />
      <input
        *ngIf="infCount !== null"
        id="infCount"
        name="infCount"
        type="hidden"
        value="{{ infCount }}"
      />
      <!-- hidden fields -->
    </form>
  </div>
</div>

<div>
  <form #mpmForm [action]="loginPageURL" method="POST">
    <input [value]="refreshURL" name="refreshURL" type="hidden" />
  </form>
</div>
